'use client';

import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { ContactTabContainer, ContactTabIcon, ContactTabTitle } from '../contact-tabs';

export function ContactTabsBilling() {
  const generalLayout = useGlobalStore(state => state.generalLayout);
  const { t } = useTranslations();

  return (
    <ContactTabContainer>
      <div className="flex w-full items-start justify-between gap-4">
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <ContactTabTitle title={t('text679')} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <p className="text-sm font-light sm:text-base">
              {generalLayout.contact?.company || generalLayout.site_name || ''}
            </p>
            <p className="text-sm font-light sm:text-base">{generalLayout.contact?.address},</p>
            <p className="text-sm font-light sm:text-base">
              {generalLayout.contact?.postcode} {generalLayout.contact?.city}
            </p>
            <p className="text-sm font-light sm:text-base">{generalLayout.contact?.country.name}</p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text42')}:&nbsp;</span>
              {generalLayout.contact?.ico}
            </p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text43')}:&nbsp;</span>
              {generalLayout.contact?.dic}
            </p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text44')}:&nbsp;</span>
              {generalLayout.contact?.ic_dph}
            </p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text618')}:&nbsp;</span>
              {generalLayout.contact?.commercial_register}
            </p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text28')}:&nbsp;</span>
              {generalLayout.contact?.iban}
            </p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text1332')}:&nbsp;</span>
              {generalLayout.contact?.bank}
            </p>
            <p className="text-sm font-light sm:text-base">
              <span className="font-semibold">{t('text126')}:&nbsp;</span>
              {generalLayout.contact?.swift}
            </p>
          </div>
        </div>
        <ContactTabIcon alt={t('text690')} imageUrl="/images/icons/invoice.svg" />
      </div>
    </ContactTabContainer>
  );
}
